import api from "../../utils/api/api.utils";
export var requestInsurance = function (insuranceExternalAccessCode) {
    return api.post("/insurance/".concat(insuranceExternalAccessCode, "/publish"));
};
